import ThumbsUpIcon from '@/icons/bwi/thumbs-up.svg'

type FeedbackButtonsProps = {
  onFeedback?: (feedback: 'positive' | 'negative') => void
}

export default function FeedbackButtons({ onFeedback }: FeedbackButtonsProps) {
  return (
    <div className="flex justify-center gap-2">
      <button
        onClick={() => onFeedback?.('positive')}
        className="text-secondary-800 hover:text-primaryBlue transition-colors p-2 focus:outline-none focus:shadow-outline"
      >
        <ThumbsUpIcon className="w-4 h-4" />
      </button>
      <button
        onClick={() => onFeedback?.('negative')}
        className="text-secondary-800 hover:text-red-600 transition-colors p-2 focus:outline-none focus:shadow-outline"
      >
        <ThumbsUpIcon className="w-4 h-4 rotate-180" />
      </button>
    </div>
  )
}
